const daysOfTheWeek = [
  {
    key: '1', value: '1', title: 'Monday',
  },
  {
    key: '2', value: '2', title: 'Tuesday',
  },
  {
    key: '3', value: '3', title: 'Wednesday',
  },
  {
    key: '4', value: '4', title: 'Thursday',
  },
  {
    key: '5', value: '5', title: 'Friday',
  },
  {
    key: '6', value: '6', title: 'Saturday',
  },
  {
    key: '0', value: '0', title: 'Sunday',
  },

]

export default daysOfTheWeek
